import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import React from 'react';

const FormDialog = ({ handleClose, handleSubmit, name, open }) => {

  const [newPassword, setNewPassword] = React.useState('');

  const handleChangeNewPassword = e => {
    setNewPassword(e.target.value);
  };

  const submitPassword = () => {
    handleSubmit(newPassword);
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Nova Password</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Por favor insira a nova password para o utilizador {name}.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="new_password"
            label="Password nova"
            type="password"
            fullWidth
            value={newPassword}
            onChange={handleChangeNewPassword}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button onClick={submitPassword} color="primary">
            Submeter
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FormDialog;
